import type { UserPermissionType } from '../services/AuthService/types';

export type Navigation = NavigationSubMenu[];

export interface NavigationLink {
  name: string;
  path: string;
  requiredPermission?: UserPermissionType;
  requiredFeatureMap?: Record<string, boolean>;
  requiredOptinMap?: Record<string, boolean>;
  shipiumAdmin?: boolean;
  hideInEu?: boolean;
  icon?: string;
  group?: string;
  external?: boolean;
  ignoreSubMenuPath?: boolean;
  tag?: string;
}

export interface NavigationSubMenu extends NavigationLink {
  links?: NavigationSubMenu[];
}

export interface ModalToggleParams {
  key: string;
  open: boolean;
  params?: ModalParams;
}

export interface ModalParams {
  mode?: 'edit' | 'add' | 'view';
  [x: string]: any;
}

export interface ModalState {
  open: boolean;
  params?: ModalParams;
}

export const RoleHierarchy: Record<UserPermissionType, number> = {
  site_manager: 1,
  site_associate: 1,
  viewer: 1,
  returns_associate: 2,
  editor: 3,
  administrator: 4,
};
